<template>
  <div>
    <!-- Start Header Area -->
    <Header>
      <img slot="logo" :src="logo" />
    </Header>
    <!-- End Header Area -->

    <!-- Start Breadcrump Area  -->
    <div
      class="breadcrumb-area ptb--120 blog-header-dark"
      data-black-overlay="6"
    >
      <v-container>
        <v-row>
          <v-col lg="12">
            <div class="breadcrumb-inner pt--100">
              <h2 class="heading-title">Blog</h2>
              <p class="description">Conteúdo para decisores: tecnologia, eficiência e inovação.</p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Breadcrump Area  -->

    <!-- Start blog Area  -->
    <div class="rn-blog-area ptb--120 bg_color--1">
      <v-container>
        <BlogThree />
        <v-row>
          <v-col lg="12">
            <div class="text-center rn-pagination mt--60 mt_sm--30">
              <!-- <Pagination /> -->
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- Start blog Area  -->

    <Footer />
  </div>
</template>

<script>
  import Header from "../../components/header/Header";
  import BlogThree from "../../components/blog/BlogThree";
  import Pagination from "../../components/pagination/Pagination";
  import Footer from "../../components/footer/Footer";
  export default {
    components: {
      Header,
      BlogThree,
      Pagination,
      Footer,
    },
    data() {
      return {
        logo: "/logoCodetimeWhite.webp",
      };
    },

    methods: {},
  };
</script>

<style scoped>
.blog-header-dark {
  background: linear-gradient(160deg, rgba(10, 11, 16, 0.85) 0%, rgba(14, 18, 32, 0.80) 45%, rgba(10, 20, 36, 0.85) 100%),
              url('../../assets/images/blog/blog-header-bg.png');
  background-size: cover;
  background-position: center;
  position: relative;
  overflow: hidden;
}

.blog-header-dark::before {
  content: "";
  position: absolute;
  inset: -10% -10% -10% -10%;
  background:
    radial-gradient(600px 320px at 15% 25%, rgba(0, 140, 247, 0.12), transparent 60%),
    radial-gradient(760px 420px at 85% 70%, rgba(249, 93, 129, 0.10), transparent 65%);
  pointer-events: none;
  z-index: 0;
}

.blog-header-dark .breadcrumb-inner {
  position: relative;
  z-index: 1;
  text-align: center;
}

.blog-header-dark .heading-title {
  color: #fff;
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 16px;
}

.blog-header-dark .description {
  color: rgba(255, 255, 255, 0.7);
  font-size: 18px;
  max-width: 600px;
  margin: 0 auto;
}
</style>

<style>
/* Logo size fix for blog pages */
.default-header .logo img {
  max-height: 30px !important;
}
</style>
